import { useState, useCallback } from 'react';

// Import hooks
import usePrev from './usePrev';

const useBoolean = (defaultValue = false) => {
	const [value, setValue] = useState(Boolean(defaultValue));
	const previous = usePrev(value);

	const setTrue = useCallback(() => setValue(true), []);
	const setFalse = useCallback(() => setValue(false), []);
	const toggle = useCallback(() => setValue((value) => !value), []);
	const update = useCallback((newValue) => setValue(Boolean(newValue)), []);

	return [
		value,
		{
			update,
			previous,
			setTrue,
			setFalse,
			toggle
		}
	];
};

export default useBoolean;
